import type { ReactNode } from 'react';

export const symbol_quickreply: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M240-240 131-131q-14 14-32.5 6.34Q80-132.31 80-152v-668q0-24 18-42t42-18h680q24 0 42 18t18 42v250q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-250H140v600l74-80h402q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H240Zm526 0h-30.18q-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-180q0-12.75 8.63-21.38Q723.25-480 736-480h84q11 0 18 9.5t3 20.5l-48 140h53q12 0 19 10t2 21L780-74q-2 6-8 4.5t-6-7.5v-163Zm-626-60v-520 520Z"
		/>
	</svg>
);
